import { Breakpoints } from '../grid';

export default function isMobileBreakpoint() {
    return typeof window !== 'undefined' && window.innerWidth < Breakpoints.small;
}
